var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { InputLabel } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Icon from '@material-ui/core/Icon';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { isArray } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import Select, { components } from 'react-select';
import { useAsync, UseAsyncStatus } from '../Hooks/useAsync';
import { CancelledRequest, useHttpConfig } from '../Shared/HttpRequestExecutor';
import { AutoCompleteTypes } from './MaskedTextField';
import { ReadOnlyField } from './ReadOnlyField';
import { StyledChip } from './StyledChip';
import styles from './StyledSelect.module.css';
function isAdditionalActionButtonType(option) {
    if (option === null || option === undefined)
        return false;
    if (Array.isArray(option))
        return false;
    if ('_isActionButton' in option)
        return true;
    return false;
}
function isValueTypeSuggestionType(option) {
    if (option === null || option === undefined)
        return true;
    if (Array.isArray(option))
        return true;
    return !isAdditionalActionButtonType(option);
}
function NoOptionsMessage(props) {
    if (props.selectProps.noResultsMessage)
        return React.cloneElement(props.selectProps.noResultsMessage, __assign({}, props.innerProps));
    return (React.createElement(Typography, __assign({ color: 'textSecondary', className: styles.noOptionsMessage }, props.innerProps), props.children));
}
function inputComponent(_a) {
    var inputRef = _a.inputRef, props = __rest(_a, ["inputRef"]);
    return React.createElement("div", __assign({ ref: inputRef }, props));
}
function simpleInputComponent(_a) {
    var inputRef = _a.inputRef, props = __rest(_a, ["inputRef"]);
    return React.createElement("div", __assign({ className: styles.simpleInput, ref: inputRef }, props));
}
function Control(props) {
    var _a, _b;
    var helperTextType = 'normal';
    var unifiedHelperText = props.selectProps.errorText || props.selectProps.warningText || props.selectProps.helperText || '';
    if (props.selectProps.errorText) {
        helperTextType = 'error';
    }
    else if (props.selectProps.warningText) {
        helperTextType = 'warning';
    }
    var formControlClasses = classNames(styles.formControl, (_a = {},
        _a[styles.errorState] = helperTextType === 'error',
        _a));
    var autoCompleteValue = props.selectProps.autoCompleteType === AutoCompleteTypes.UserInfo ? 'off-no-complete' : 'off';
    var labelClass = props.isDisabled ? styles.disabledInputLabel : styles.inputLabel;
    var labelClasses = {
        root: labelClass
    };
    var inputClasses = {
        root: styles.inputRoot,
        focused: styles.inputFocused,
        input: styles.input
    };
    var formHelperTextClasses = {
        root: classNames(styles.helperText, (_b = {},
            _b[styles.warning] = helperTextType === 'warning',
            _b))
    };
    return (React.createElement(FormControl, { error: !!props.selectProps.errorText, disabled: !!props.selectProps.disabled, fullWidth: true, classes: { root: formControlClasses }, "data-test-id": "single-select-input_" + props.selectProps.testId },
        !props.selectProps.collapseTitleLabel && (React.createElement(InputLabel, { shrink: true, classes: labelClasses },
            props.selectProps.label || '',
            props.selectProps.required && React.createElement("span", { className: styles.requiredLabel }, " *"))),
        React.createElement(Input, { inputProps: __assign({ className: styles.input, inputRef: props.innerRef, children: props.children, disabled: props.selectProps.disabled, readOnly: props.selectProps.readOnly, 'data-lpignore': 'true' }, props.innerProps), "data-test-id": "single-select-menu-input_" + props.selectProps.testId, autoComplete: autoCompleteValue, disabled: props.selectProps.disabled, readOnly: props.selectProps.readOnly, 
            // Our placeholder gets restricted to string but gets encapsulated as react node from the select props
            placeholder: props.selectProps.placeholder, classes: inputClasses, inputComponent: inputComponent, className: styles.input, inputRef: props.innerRef }),
        (!props.selectProps.hideWarningEmptyHelperText || unifiedHelperText) && (React.createElement(FormHelperText, { classes: formHelperTextClasses }, unifiedHelperText || ' '))));
}
function SimpleControl(props) {
    var _a;
    var helperTextType = 'normal';
    var unifiedHelperText = props.selectProps.errorText || props.selectProps.warningText || props.selectProps.helperText;
    var inputClasses = {
        root: styles.inputRoot,
        input: styles.input
    };
    if (props.selectProps.errorText) {
        helperTextType = 'error';
    }
    else if (props.selectProps.warningText) {
        helperTextType = 'warning';
    }
    var formHelperTextClasses = {
        root: classNames(styles.helperText, (_a = {},
            _a[styles.warning] = helperTextType === 'warning',
            _a[styles.error] = helperTextType === 'error',
            _a))
    };
    var autoCompleteValue = props.selectProps.autoCompleteType === AutoCompleteTypes.UserInfo ? 'off-no-complete' : 'off';
    var simpleModeConfig = props.selectProps.simpleMode;
    return (React.createElement(FormControl, { error: !!props.selectProps.errorText, disabled: !!props.selectProps.disabled, fullWidth: true, "data-test-id": "single-select-input_" + props.selectProps.testId },
        React.createElement(Input, { inputProps: __assign({ className: classNames(styles.input, simpleModeConfig.className), inputRef: props.innerRef, children: props.children, readOnly: props.selectProps.readOnly }, props.innerProps), autoComplete: autoCompleteValue, readOnly: props.selectProps.readOnly, 
            // Our placeholder gets restricted to string but gets encapsulated as react node from the select props
            placeholder: props.selectProps.placeholder, classes: inputClasses, inputComponent: simpleInputComponent, className: styles.inputSimple, disableUnderline: true }),
        (!props.selectProps.hideWarningEmptyHelperText || unifiedHelperText) && (React.createElement(FormHelperText, { classes: formHelperTextClasses }, unifiedHelperText || ' '))));
}
function Option(props) {
    var _a, _b;
    var contents = props.children;
    var index = props.options.findIndex(function (it) { return props.selectProps.itemToMenuKey(props.data) === props.selectProps.itemToMenuKey(it); });
    var dataTestId = "single-select-menu-item-" + index;
    if (props.selectProps.additionalActionButton && ((_a = props.data) === null || _a === void 0 ? void 0 : _a._isActionButton)) {
        var actionButtonRenderValue = props.selectProps.additionalActionButton.render((_b = props.selectProps.asyncInputValue) !== null && _b !== void 0 ? _b : props.selectProps.inputValue, props.options ? props.options.filter(function (x) { return !isAdditionalActionButtonType(x); }) : []);
        if (actionButtonRenderValue === null || actionButtonRenderValue === undefined)
            return null;
        contents = React.cloneElement(actionButtonRenderValue, {
            'data-test-id': dataTestId
        });
    }
    else {
        if (props.selectProps.suggestionCustomItemRender) {
            var suggestionCustomItemRenderValue = props.selectProps.suggestionCustomItemRender(props.data);
            if (suggestionCustomItemRenderValue === null || suggestionCustomItemRenderValue === undefined)
                return null;
            contents = React.cloneElement(suggestionCustomItemRenderValue, {
                'data-test-id': dataTestId
            });
        }
        else if (props.selectProps.customItemRender) {
            var customItemRenderValue = props.selectProps.customItemRender(props.data);
            if (customItemRenderValue === null || customItemRenderValue === undefined)
                return null;
            contents = React.cloneElement(customItemRenderValue, {
                'data-test-id': dataTestId
            });
        }
    }
    return (React.createElement(MenuItem, __assign({ buttonRef: props.innerRef, selected: props.isFocused, component: 'div', style: {
            fontWeight: props.isSelected ? 600 : 400,
            minHeight: 24,
            maxHeight: 65,
            height: 'auto',
            display: 'block',
            textOverflow: 'ellipsis',
            whiteSpace: props.selectProps.wrapOptions ? 'normal' : 'nowrap'
        }, "data-test-id": dataTestId }, props.innerProps), contents));
}
function Placeholder(props) {
    return (React.createElement(Typography, __assign({ color: 'textSecondary', className: styles.placeholder }, props.innerProps), props.selectProps.placeHolder));
}
function SingleValue(props) {
    if (props.selectProps.selectedCustomItemRender) {
        var selectedItemCustomRenderValue = props.selectProps.selectedCustomItemRender(props.data);
        if (selectedItemCustomRenderValue === null || selectedItemCustomRenderValue === undefined)
            return null;
        return React.cloneElement(selectedItemCustomRenderValue, __assign({}, props.innerProps));
    }
    else if (props.selectProps.customItemRender) {
        var customItemRenderValue = props.selectProps.customItemRender(props.data);
        if (customItemRenderValue === null || customItemRenderValue === undefined)
            return null;
        return React.cloneElement(customItemRenderValue, __assign({}, props.innerProps));
    }
    return (React.createElement(Typography, __assign({ className: styles.singleValue }, props.innerProps), props.children));
}
function ValueContainer(props) {
    var _a;
    var _b;
    var classes = classNames(styles.valueContainer, (_a = {},
        _a[styles.fixedHeight] = (_b = props.selectProps) === null || _b === void 0 ? void 0 : _b.simpleMode,
        _a[styles.notSearchable] = props.selectProps.isSearchable !== undefined && !props.selectProps.isSearchable,
        _a[styles.noFlexWrap] = props.selectProps.noWrapValue,
        _a));
    return React.createElement("div", { className: classes }, props.children);
}
function MultiValue(props) {
    var _a;
    var icon = props.selectProps.getMultiValueChipIcon
        ? props.selectProps.getMultiValueChipIcon(props.data)
        : undefined;
    if (props.selectProps.hideMultiChips) {
        return null;
    }
    return (React.createElement(StyledChip, { avatar: icon, tabIndex: -1, 
        // Type here is wrong children is always a string
        label: props.children, hasAccent: true, maxLength: 25, focused: props.isFocused, onRemove: props.removeProps.onClick, hasError: ((_a = props.selectProps) === null || _a === void 0 ? void 0 : _a.itemHasError) ? props.selectProps.itemHasError(props.data) : false, testId: props.selectProps.testId + "-" + props.selectProps.itemToMenuKey(props.data) }));
}
function MenuList(props) {
    return (React.createElement("div", { className: styles.menuList, "data-test-id": 'single-select-menu' }, props.children));
}
function Menu(props) {
    var _a;
    return (React.createElement("div", { className: classNames((_a = {},
            _a[styles.hasMoreContainer] = props.selectProps.hasMoreResults,
            _a)) },
        React.createElement(components.Menu, __assign({}, props),
            React.createElement("div", { className: styles.dropdownBody },
                props.children,
                props.selectProps.hasMoreResults && (React.createElement(Typography, { className: styles.maxResults }, "More results found - type to refine"))))));
}
function InputComponent(props) {
    return React.createElement(components.Input, __assign({}, props, { className: styles.forceInputFontFamily }));
}
function ClearIndicator(props) {
    var _a;
    var buttonClasses = {
        root: classNames(styles.clearButton, (_a = {},
            _a[styles.clearButtonFocused] = props.isFocused,
            _a))
    };
    return (React.createElement(Button, __assign({}, props.innerProps, { size: 'small', classes: buttonClasses, "data-test-id": "single-select-clear_" + props.selectProps.testId, tabIndex: -1 }),
        React.createElement(Icon, { classes: { root: styles.iconRoot } }, "cancel")));
}
function DropdownIndicator(props) {
    return (React.createElement("div", __assign({}, props.innerProps, { className: styles.arrowIcon, "data-test-id": "single-select-drop-down_" + props.selectProps.testId }), props.selectProps.menuIsOpen ? React.createElement(Icon, null, "arrow_drop_up") : React.createElement(Icon, null, "arrow_drop_down")));
}
var loadingIndicator = function (css) {
    css.position = 'absolute';
    css.right = 31;
    css.backgroundColor = 'transparent';
    return css;
};
var styleOverrides = {
    loadingIndicator: loadingIndicator,
    menuPortal: function (base) { return (__assign(__assign({}, base), { width: 'auto', minWidth: base.width + 'px', maxWidth: '600px', zIndex: 9999 })); }
};
var themeOverride = function (theme) { return (__assign(__assign({}, theme), { borderRadius: 0, spacing: __assign(__assign({}, theme.spacing), { menuGutter: 1 }) })); };
function alwaysTrueFilterOptions() {
    return true;
}
export function isSingleSelectSingleValue(item) {
    if (item) {
        if (item.length === undefined && !isArray(item))
            return true;
    }
    return false;
}
// From react-select docs
// minMenuHeight: Minimum height of the menu before flipping
// Default option height is 42 (26 + 2x8 padding).
// If you pass in optionHeight prop make sure it's the total height of options.
// More results message height is 40.
function calcMinMenuHeight(props, moreResults, resultLength) {
    var _a;
    var optionHeight = (_a = props.optionHeight) !== null && _a !== void 0 ? _a : 42;
    var maxResults = props.maxResults > 0 ? props.maxResults : resultLength;
    if (props.additionalActionButton)
        maxResults++;
    var minHeight = optionHeight * maxResults;
    if (moreResults)
        minHeight += 40;
    return minHeight;
}
export function StyledSelect(props) {
    var _this = this;
    var httpConfig = useHttpConfig();
    function getItemDisplayValue(value) {
        var icon = props.getMultiValueChipIcon
            ? props.getMultiValueChipIcon(value)
            : undefined;
        return props.customItemRender ? (props.customItemRender(value)) : props.isMulti ? (React.createElement(StyledChip, { avatar: icon, key: props.itemToMenuKey(value), tabIndex: -1, label: props.itemToString(value), hasAccent: true, maxLength: 25, readOnly: true, testId: "chip-" + props.itemToString(value) })) : (props.itemToString(value));
    }
    var _a = __read(useState(false), 2), menuOpen = _a[0], setMenuOpen = _a[1];
    var firstLoadRef = useRef(true);
    var firstLoad = firstLoadRef.current;
    var searchText = useRef('');
    var itemToString = function (item) {
        return isValueTypeSuggestionType(item)
            ? props.itemToString(item)
            : props.additionalActionButton
                ? props.additionalActionButton.displayText(searchText.current)
                : 'itemToString:AdditionalActionButton';
    };
    var itemToKey = props.itemToMenuKey
        ? function (item) {
            return isValueTypeSuggestionType(item) ? props.itemToMenuKey(item) : 'itemToKey:AdditionalActionButton';
        }
        : itemToString;
    var replacementComponents = {
        Control: props.simpleMode ? SimpleControl : Control,
        Menu: Menu,
        MultiValue: MultiValue,
        NoOptionsMessage: NoOptionsMessage,
        Option: Option,
        MenuList: MenuList,
        Placeholder: Placeholder,
        SingleValue: SingleValue,
        ValueContainer: ValueContainer,
        ClearIndicator: ClearIndicator,
        Input: InputComponent,
        DropdownIndicator: props.simpleMode ? undefined : DropdownIndicator
    };
    if (!props.fetch && !props.suggestions)
        console.error('Single Select has been given no fetch or suggestions');
    var errorAPICallback = function () { return Promise.reject('Error, no fetch function given to ASYNC select'); };
    var asyncFunction = props.fetch
        ? function (config, inputValue, limit) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = [];
                        if (!props.fetch) return [3 /*break*/, 2];
                        return [4 /*yield*/, props.fetch(config, inputValue, limit)];
                    case 1:
                        result = _a.sent();
                        searchText.current = inputValue;
                        _a.label = 2;
                    case 2: return [2 /*return*/, result];
                }
            });
        }); }
        : errorAPICallback;
    var queryAmount = props.maxResults > 0 ? props.maxResults + 1 : 0;
    var asyncFetchState = useAsync({
        defaultValue: [],
        httpConfig: httpConfig,
        useCache: props.useCache === undefined ? true : props.useCache,
        getApi: asyncFunction
    });
    useEffect(function () {
        function fetchFirstResult() {
            return __awaiter(this, void 0, void 0, function () {
                var results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(props.selectFirstAsyncResult && props.fetch && props.onSelection)) return [3 /*break*/, 2];
                            return [4 /*yield*/, props.fetch(httpConfig, '', 1)];
                        case 1:
                            results = _a.sent();
                            if (results instanceof CancelledRequest)
                                return [2 /*return*/];
                            firstLoadRef.current = false;
                            if (results.length > 0)
                                props.onSelection(results[0]);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        if (firstLoad && !props.value && props.fetch && props.selectFirstAsyncResult) {
            fetchFirstResult();
        }
    }, []);
    function onSelection(value) {
        if (!props.onSelection)
            return;
        if (isValueTypeSuggestionType(value))
            props.onSelection(value);
        if (isAdditionalActionButtonType(value) && props.additionalActionButton)
            props.additionalActionButton.onSelection(searchText.current);
    }
    if (props.readOnly) {
        var output = !props.value
            ? ''
            : !Array.isArray(props.value)
                ? getItemDisplayValue(props.value)
                : props.value.map(getItemDisplayValue);
        return (React.createElement(ReadOnlyField, { label: props.label || null, mode: 'field', noWrapping: props.noWrapReadOnly, hideHelperText: props.hideWarningEmptyHelperText }, output));
    }
    var selectProps = __assign(__assign({}, props), { ref: props.selectRef, styles: props.simpleMode ? undefined : styleOverrides, components: replacementComponents, getOptionLabel: itemToString, getOptionValue: itemToKey, value: props.value, isMulti: props.isMulti, isClearable: props.isClearable, hideSelectedOptions: false, onChange: onSelection, placeholder: props.placeHolder, isDisabled: props.disabled, theme: themeOverride, minMenuHeight: 241, wrapOptions: props.wrapOptions });
    if (props.fetch) {
        var results = asyncFetchState.data || [];
        var hasMoreResults = false;
        if (props.maxResults > 0) {
            hasMoreResults = results.length > props.maxResults && asyncFetchState.status === UseAsyncStatus.Loaded;
            if (results.length > props.maxResults) {
                results = results.filter(function (x, i) { return i < props.maxResults; });
            }
        }
        if (props.additionalActionButton) {
            results = __spreadArray(__spreadArray([], __read(results), false), [{ _isActionButton: true }], false);
        }
        var handleInputChange_1 = function (value, reason) {
            if (reason.action === 'input-change') {
                asyncFetchState.debouncedGetApi(value, queryAmount);
            }
        };
        var handleMenuOpen = function () {
            if (!menuOpen) {
                setMenuOpen(true);
                props.onOpen && props.onOpen(true);
                asyncFetchState.getApi('', queryAmount);
            }
        };
        var handleMenuClose = function () {
            setMenuOpen(false);
            props.onOpen && props.onOpen(false);
        };
        return (React.createElement(Select, __assign({}, selectProps, { filterOption: alwaysTrueFilterOptions, menuPortalTarget: document.getElementById('menu-portal'), hasMoreResults: hasMoreResults, menuPosition: 'fixed', menuPlacement: 'auto', onInputChange: handleInputChange_1, 
            // don't open until loading finishes.  stay open for reloads
            menuIsOpen: menuOpen &&
                asyncFetchState.status !== UseAsyncStatus.Loading &&
                (asyncFetchState.status !== UseAsyncStatus.Reloading || !props.hideOptionsWhenReloading), onMenuOpen: handleMenuOpen, onMenuClose: handleMenuClose, isLoading: asyncFetchState.status === UseAsyncStatus.Reloading ||
                asyncFetchState.status === UseAsyncStatus.Loading, options: results, asyncInputValue: searchText.current, minMenuHeight: calcMinMenuHeight(props, hasMoreResults, results.length) })));
    }
    // Non-async render
    var suggestions = props.suggestions || [];
    if (props.additionalActionButton) {
        suggestions = __spreadArray(__spreadArray([], __read(suggestions), false), [{ _isActionButton: true }], false);
    }
    var handleInputChange = function (value, reason) {
        if (reason.action === 'input-change') {
            searchText.current = value;
        }
    };
    return (React.createElement(Select, __assign({}, selectProps, { isSearchable: props.isSearchable, menuPortalTarget: document.getElementById('menu-portal'), menuPosition: 'fixed', menuPlacement: 'auto', options: suggestions, onInputChange: handleInputChange })));
}
